import React from "react";
import styles from '../cssmodules/Loader.module.css';


const DefaultLoader = () => {
    return ( 
        <div className={styles.default_loader_wrapper}>
            <div className={styles.loader}></div>
            <div className={styles.default_loader_text}>Taking you there....</div>
        </div>
    );
}
 
export default DefaultLoader;